import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as FiIcons from "react-icons/fi";

import { useClient } from "../../context/ClientContext";
import SafeIcon from "../../common/SafeIcon";

const { FiLoader, FiLogOut } = FiIcons;

export default function SignOutButton() {
  const { logout } = useClient();
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSignOut = async () => {
    if (submitting) return;

    setSubmitting(true);
    setError("");

    try {
      const result = await logout();

      if (!result?.success) {
        setError(result?.error || "Unable to sign out.");
        return;
      }

      navigate("/login", {
        replace: true,
      });
    } catch (err) {
      setError(err?.message || "Unable to sign out.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        disabled={submitting}
        onClick={handleSignOut}
        className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50"
      >
        <SafeIcon
          icon={submitting ? FiLoader : FiLogOut}
          className={submitting ? "animate-spin" : ""}
        />

        Sign Out
      </button>

      {error && (
        <p
          role="alert"
          className="mt-2 text-xs text-red-600"
        >
          {error}
        </p>
      )}
    </div>
  );
}